import { IState } from '../../../store';
import { selectOfferAgent } from '../selectOfferAgent';

export const selectIsSubAgent = (state: IState): boolean => {
  const agent = selectOfferAgent(state);

  return !!agent?.isSubAgent;
};
